import React from 'react';
import { IconActivity } from 'design-system/icons';
import IconGraph from 'design-system/icons/IconGraph';
import IconPieChart from 'design-system/icons/IconPieChart';
import { ChartType } from './types';
export const CHART_TYPE_ICONS = {
    [ChartType.income_spending]: <IconGraph gradientKey="darkPurple"/>,
    [ChartType.over_time]: <IconActivity alt gradientKey="apricot"/>,
    [ChartType.categories]: <IconPieChart gradientKey="deepPink"/>,
};
export const CHART_TYPE_OPTIONS = [
    {
        label: 'Income vs spending',
        value: ChartType.income_spending,
        icon: CHART_TYPE_ICONS[ChartType.income_spending],
    },
    {
        label: 'Spend over time',
        value: ChartType.over_time,
        icon: CHART_TYPE_ICONS[ChartType.over_time],
    },
    {
        label: 'Category pie chart',
        value: ChartType.categories,
        icon: CHART_TYPE_ICONS[ChartType.categories],
    },
];
export const CHART_TYPE_OPTIONS_WALKTHROUGH = CHART_TYPE_OPTIONS.map((option) => {
    if (option.value === ChartType.over_time) {
        return option;
    }
    return {
        ...option,
        disabled: true,
    };
});
